import { createContext } from 'react';

export type CheckboxState = {
  checked: boolean;
  setCheckboxState: (checked: boolean) => void;
  disabled: boolean;
  setDisabled: (disabled: boolean) => void;
  displayHelperText: boolean;
  setDisplayHelperText: (displayHelperText: boolean) => void;
};

export const CheckboxContext = createContext<CheckboxState>({
  checked: false,
  setCheckboxState: () => {},
  disabled: true,
  setDisabled: () => {},
  displayHelperText: false,
  setDisplayHelperText: () => {},
});
